export class FunnelsNotFoundError extends Error {
  constructor() {
    super('Funnels not found');
  }
}
